import { render, staticRenderFns } from "./DownloadLibrary.vue?vue&type=template&id=9a6c160a&scoped=true"
import script from "./DownloadLibrary.vue?vue&type=script&lang=js"
export * from "./DownloadLibrary.vue?vue&type=script&lang=js"
import style0 from "./DownloadLibrary.vue?vue&type=style&index=0&id=9a6c160a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c160a",
  null
  
)

export default component.exports